import type { ChatStore } from '../stores'

export interface SessionTokenTotals {
  inputTokens: number
  outputTokens: number
  costMicros: number
}

type TokenDirection = 'input' | 'output'

const USAGE_KEYS: Record<TokenDirection, 'input_tokens' | 'output_tokens'> = {
  input: 'input_tokens',
  output: 'output_tokens',
}

const STEP_KEYS: Record<TokenDirection, 'inputTokens' | 'outputTokens'> = {
  input: 'inputTokens',
  output: 'outputTokens',
}

function readNumber(value: unknown): number {
  return typeof value === 'number' ? value : 0
}

function sumTokens(state: ChatStore, direction: TokenDirection): number {
  const usageKey = USAGE_KEYS[direction]
  const stepKey = STEP_KEYS[direction]
  let total = 0
  for (const message of state.messages) {
    if (message.role !== 'assistant' || !message.usage) continue
    const usage = message.usage as Record<string, unknown>
    total += readNumber(usage[usageKey])
    if (direction === 'input') {
      total += readNumber(usage.cache_read_input_tokens)
      total += readNumber(usage.cache_creation_input_tokens)
    }
  }
  if (
    state.draftAssistant &&
    state.draftAssistant.sessionId === state.currentSessionId
  ) {
    for (const step of state.draftAssistant.stepUsages) {
      total += step[stepKey]
      if (direction === 'input') {
        total += step.cacheReadInputTokens ?? 0
        total += step.cacheCreationInputTokens ?? 0
      }
    }
  }
  return total
}

export function sumInputTokens(state: ChatStore): number {
  return sumTokens(state, 'input')
}

export function sumOutputTokens(state: ChatStore): number {
  return sumTokens(state, 'output')
}

// Authoritative per-message cost daystrom computed (stamped on each
// assistant message by lukita) plus the live draft's per-step cost.
export function sumCostMicros(state: ChatStore): number {
  let total = 0
  for (const message of state.messages) {
    if (message.role !== 'assistant') continue
    total += readNumber(message.costMicros)
  }
  if (
    state.draftAssistant &&
    state.draftAssistant.sessionId === state.currentSessionId
  ) {
    for (const step of state.draftAssistant.stepUsages) {
      total += readNumber(step.costMicros)
    }
  }
  return total
}
